<template>
	<div class="h-full w-full">
		<div
			class="
				__setup-target-smart
				__section
				shadow-sm
				bg-white
				overflow-hidden
			"
		>
			<div
				class="
					__section__header
					font-semibold
					text-neutral-600
					p-6
					border-b
				"
			>
				<div class="text-neutral-600">Thành phần của mục tiêu</div>
				<div
					class="text-neutral-500 font-normal leading-5 text-sm mt-2"
				>
          Mục tiêu mặc định gồm có Lĩnh Vực và Nội Dung.
          Bạn có thể tuỳ chỉnh các mục sau đây để thiết lập các thành phần khác cho mục tiêu.
				</div>
			</div>
			<div class="__section__content">
				<div class="form-group">
					<div
						class="
							input-group
							flex-nowrap flex
							items-center
							justify-between
							p-6
							bg-neutral-50
						"
					>
						<div
							class="
								input-group__label
								w-56
								text-neutral-500
								font-normal
							"
						>
							Mức độ hỗ trợ
						</div>
						<SwitchButton
							v-model:value="enable_goal_assistance_level"
						/>
					</div>
					<div
						class="
							input-group
							flex-nowrap flex
							items-center
							justify-between
							p-6
						"
					>
						<div
							class="
								input-group__label
								w-56
								text-neutral-500
								font-normal
							"
						>
							Cơ sở hợp lý của mục tiêu
						</div>
						<SwitchButton v-model:value="enable_goal_reason" />
					</div>
					<div
						class="
							input-group
							flex-nowrap flex
							items-center
							justify-between
							p-6
							bg-neutral-50
						"
					>
						<div
							class="
								input-group__label
								w-56
								text-neutral-500
								font-normal
							"
						>
							Chiến lược cho mục tiêu
						</div>
						<SwitchButton v-model:value="enable_goal_strategy" />
					</div>
					<div
						class="
							input-group
							flex-nowrap flex
							items-center
							justify-between
							p-6
						"
					>
						<div
							class="
								input-group__label
								w-56
								text-neutral-500
								font-normal
							"
						>
							Quy trình thực hiện mục tiêu
						</div>
						<SwitchButton v-model:value="enable_goal_process" />
					</div>
				</div>
			</div>
		</div>
		<div
			class="
				__setup-target-smart
				__section
				shadow-sm
				bg-white
				overflow-hidden
				mt-10
			"
			v-if="!isLitePackage"
		>
			<div
				class="
					__section__header
					font-semibold
					text-neutral-600
					p-6
					border-b
				"
			>
				<div class="text-neutral-600">Phụ huynh xem chi tiết mục tiêu</div>

				<div
					class="text-neutral-500 font-normal leading-5 text-sm mt-2"
					style="max-width: 700px"
				>
					Ở chế độ bật, Phụ huynh có thể xem được chi tiết mục tiêu
				</div>
			</div>
			<div class="__section__content">
				<div class="form-group">
					<div
						class="
							input-group
							flex-nowrap flex
							items-center
							justify-between
							p-6
							bg-neutral-50
						"
					>
						<div
							class="
								input-group__label
								w-56
								uppercase
								text-neutral-400 text-xs
								font-semibold
							"
						>
							Phụ huynh xem chi tiết mục tiêu
						</div>
						<SwitchButton v-model:value="enable_parent_view_goal_details" />
					</div>
				</div>
			</div>
		</div>
		<AssistanceLevel></AssistanceLevel>
		<SetupGoals></SetupGoals>
	</div>
</template>

<script>
import { Vue, Options } from 'vue-class-component';
import SwitchButton from '@/components/elements/switchButton/SwitchButton.vue';
import { Prop, Watch } from 'vue-property-decorator';
import AssistanceLevel from '@/views/setupCenter/features/assistanceLevel/AssistanceLevel.vue';
import SetupGoals from '@/views/setupGoals/SetupGoals.vue';
import { isLitePackage } from '@/helper/packageTier';
import { useStore } from 'vuex';

@Options({
	name: 'TargetSmart',
	components: {
		SwitchButton,
		AssistanceLevel,
		SetupGoals
	},
})
export default class TargetSmart extends Vue {
	//----------------------- 🤍 Props 🤍 -----------------------//
	@Prop() org;
	store = useStore();
	//----------------------- 🤍 Data 🤍 -----------------------//
	enable_goal_process = false;
	enable_goal_reason = false;
	enable_goal_strategy = false;
	enable_goal_assistance_level = false;
	enable_parent_view_goal_details = false;
	onChange = false;
	onWatchOrg = true;
	get isLitePackage() {
		return isLitePackage(this.store.state.profile);
	}
	//----------------------- 🤍 Watch 🤍 -----------------------//
	@Watch('org', { deep: true, immediate: true })
	onOrgChange(org) {
		if (org && this.onWatchOrg) {			
			this.enable_goal_process = org?.enable_goal_process;
			this.enable_goal_reason = org?.enable_goal_reason;
			this.enable_goal_strategy = org?.enable_goal_strategy;
			this.enable_parent_view_goal_details = org?.enable_parent_view_goal_details;
			this.enable_goal_assistance_level =
				org?.enable_goal_assistance_level;
			setTimeout(() => {
				this.onChange = true;
			}, 1000);
			this.onWatchOrg = false;
		}
	}


	@Watch('enable_goal_process')
	onGoalProcess(value) {
		if (this.onChange) {
			this.$emit('updateOrg', {
				enable_goal_process: value,
			});
		}
	}

	@Watch('enable_goal_reason')
	onGoalReason(value) {
		if (this.onChange) {
			this.$emit('updateOrg', {
				enable_goal_reason: value,
			});
		}
	}

	@Watch('enable_goal_strategy')
	onGoalStrategy(value) {
		if (this.onChange) {
			this.$emit('updateOrg', {
				enable_goal_strategy: value,
			});
		}
	}

	@Watch('enable_goal_assistance_level')
	onGoalAssistance(value) {
		if (this.onChange) {
			this.$emit('updateOrg', {
				enable_goal_assistance_level: value,
			});
		}
	}

	@Watch('enable_parent_view_goal_details')
	onParentViewGoalDetails(value) {
		if (this.onChange) {
			this.$emit('updateOrg', {
				enable_parent_view_goal_details: value,
			});
		}
	}
}
</script>
